export default {
 TITLE:'Does this company have shares in other companies?',
 SUBTITLE:'Company equity',
 TOOLTIP:'<b>Shares</b> are units of ownership in a company. Find out more about share ownership and company control.  ',
 TOOLTIP_NOT_ADD:'When you\'re ready, you can manage equity on Clara. ',
 TOOLTIP_IS_EXIST:'Lucky them! Shoot for the moon together…',
}